import D2C_ProviderStorage from './Storage'

class D2C_ProviderSFTP extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 51
  static providerType = 'SFTP'
  static providerTitle = 'SFTP'
  static fields = {
    ...D2C_ProviderStorage.fields,
    endpoint: {
      default: '',
      label: 'Endpoint',
      path: 'auth.endpoint',
      required: true,
      width: 5,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
    port: {
      default: 22,
      label: 'Port',
      path: 'auth.port',
      placeholder: '22',
      required: false,
      width: 3,
      validate(value) {
        return (!value || (value && value > 0 && value < 65535)) ? null : 'Must be a number between 1 and 65535'
      },
      creating: {},
    },
    login: {
      default: '',
      label: 'Login',
      path: 'auth.login',
      placeholder: '',
      required: true,
      width: 4,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
    password: {
      default: '',
      label: 'Password',
      path: 'auth.password',
      placeholder: '',
      required: true,
      width: 4,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
  }
}

export default D2C_ProviderSFTP
